import {
  Drawer,
  PrimaryButton,
  Typography,
} from '@changegps/horizon-component-library';
import { Box, Divider } from '@mui/material';
import { FormProvider } from 'react-hook-form';

import { AddUserDetailsForm } from '../components/AddUserDetailForm';
import { UserLicences } from '../components/UserLicences';
import { useAddUserForm, useCreateUserMutation } from '../hooks';

import { FormLayout } from './FormLayout';

interface User {
  email: string;
  first_name: string;
  last_name: string;
  position: string;
  admin: string;
  tfa_enable: string;
}

interface AddUserDrawerProps {
  onClose: (runQuery?: boolean) => void;
  open: boolean;
  user?: User;
}

export const AddUserDrawer = ({ onClose, open }: AddUserDrawerProps) => {
  const form = useAddUserForm();
  const { mutate: createUser, isPending } = useCreateUserMutation();

  const handleClose = () => {
    onClose();
  };

  const handleSubmit = form.handleSubmit((values) => {
    createUser(values, {
      onSuccess: () => {
        onClose(true);
        form.reset();
      },
    });
  });

  const renderContent = () => {
    return (
      <FormLayout
        onSubmit={handleSubmit}
        sx={{
          boxShadow: 'none !important',
          padding: '.5em',
        }}
      >
        <FormProvider {...form}>
          <AddUserDetailsForm />
          <Divider sx={{ marginY: '1em' }} />
          <UserLicences
            onSelect={(selectedLicences) => {
              form.setValue(
                'licences',
                selectedLicences.map((license) => ({
                  id: license.id.toString(),
                  tier_id: '1',
                  has_access: true,
                })),
              );
            }}
          />
        </FormProvider>
      </FormLayout>
    );
  };

  return (
    <Drawer
      sx={{ width: '900px !important' }}
      title={<Typography>Create New User</Typography>}
      onClose={handleClose}
      open={open}
      content={renderContent()}
      actions={
        <Box display="flex" gap="8px">
          <PrimaryButton onClick={() => handleSubmit()} disabled={isPending}>
            {isPending ? 'Creating...' : 'Create User'}
          </PrimaryButton>
        </Box>
      }
    />
  );
};
